


// @author: Luis C. 
// @brief: add a button on each product page leading to the signup page 
// @date: 6/11/2019 


window.onload = function(){
    // your JS here
    console.log('this is a test');
    if (document.getElementsByClassName("product-form--regular") != null) {
        var a = document.createElement('a');
        var linkText = document.createTextNode("Become a Dealer");
        a.appendChild(linkText);
        a.title = "Become a Dealer";
        a.href = "/account/register";
        console.log('executed this far'); 

        document.getElementsByClassName("product-form--regular")[0].appendChild(a);
    }
}